/* eslint-disable */
import { useEffect, useState } from 'react';
import { getClientId } from '../hookServices/clientId';
import { HOST, PORT } from '../environment';

async function fetchPortStatusSnapshot(portNumber) {
  const clientId = getClientId();
  const [statusResponse, deviceResponse] = await Promise.all([
    fetch(`${HOST}:${PORT}/api/device/v2/station/status?station_number=${portNumber}&clientUiId=${clientId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }),
    fetch(`${HOST}:${PORT}/api/device/v2/device/status?station_number=${portNumber}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }),
  ]);

  let statusData = null;
  let deviceData = null;

  if (statusResponse.ok) {
    const contentType = statusResponse.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      statusData = await statusResponse.json();
    }
  }

  if (deviceResponse.ok) {
    const contentType = deviceResponse.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      deviceData = await deviceResponse.json();
    }
  }

  return {
    isReady: deviceData?.isReadyToStart || deviceData?.readyToStart || false,
    isOccupied: Boolean(deviceData?.isOccupied || deviceData?.occupied),
    isInProgress: statusData?.lastJob?.state === 'IN_PROGRESS' || false,
    isCreated: statusData?.lastJob?.state === 'CREATED' || false,
  };
}

export function useManyPortStatuses(portNumbers) {
  const [portStatuses, setPortStatuses] = useState({});

  useEffect(() => {
    const numbers = (portNumbers || []).filter(Boolean);
    if (numbers.length === 0) {
      setPortStatuses({});
      return undefined;
    }

    let active = true;

    const fetchAll = async () => {
      try {
        const entries = await Promise.all(
          numbers.map(async portNumber => {
            try {
              const status = await fetchPortStatusSnapshot(portNumber);
              return [String(portNumber), status];
            } catch (error) {
              console.error(`Error fetching port status for ${portNumber}:`, error);
              return [String(portNumber), { isReady: false, isOccupied: false, isInProgress: false, isCreated: false }];
            }
          })
        );
        if (active) {
          setPortStatuses(Object.fromEntries(entries));
        }
      } catch (error) {
        console.error('Error fetching port statuses:', error);
      }
    };

    fetchAll();
    const interval = setInterval(fetchAll, 5000);
    return () => {
      active = false;
      clearInterval(interval);
    };
  }, [(portNumbers || []).join(',')]);

  return portStatuses;
}
